const normalizeSmsPreference = (sms) => {

    if (sms === 'on' || sms === true || sms === 1 || sms === '1') {
        return 'on';
    }

    return 'off';
};

const isSmsEnabled = (sms) => normalizeSmsPreference(sms) === 'on';

module.exports = {
    normalizeSmsPreference,
    isSmsEnabled
};
